<template>
  <main class="subjects" v-if="payload">
    <div class="subjects__overview paragraph-rules">
      <p v-html="payload.overview"></p>
    </div>
    <div class="subjects__participation">
      <p v-html="payload.participation"></p>
    </div>
  </main>
</template>

<script>
import ApiPage from '@/services/ApiPage'

export default {
  name: 'Subjects',
  extends: ApiPage,
  components: {
  },
  data() {
    return {
      payload: null
    }
  }
}
</script>

<style lang="scss" scoped>
.subjects {
  @include page;
  display:flex;
  flex-wrap:wrap;
  &__overview {
    width:50%;
    padding:0 $grid-padding 0 0;
  }
  &__participation {
    width:50%;
    padding:0 $grid-padding 0 0;
  }

  @media screen and (max-width: $mobile) {
    display:flex;
    flex-wrap: wrap;
    &__overview, &__participation {
      width:100%;
      p {
        font-size:$body--m;
      }
    }
    &__overview {
      margin:0 0 2rem 0;
    }
  }
}
</style>

<style>
strong {
  font-family: 'Helvetica', 'Arial', serif;
  font-size: 1em;
  line-height:1.25;
}
</style>
